import { Theme } from '@mui/material/styles';

/**
 * Common form styling utilities for consistent form appearance across the application
 * These styles extract patterns found in multiple components like DesignSessionReviewForm and ModelDataSampleForm
 */

/**
 * Product information section styling - used in forms to display product details
 * with consistent border, accent color, and padding
 */
export const createProductInfoStyles = (theme: Theme) => ({
  border: `1px solid #65AFAD`,
  borderLeft: `4px solid #65AFAD`,
  padding: theme.spacing(1.5),
  marginBottom: theme.spacing(2),
  backgroundColor: theme.palette.info.light + '10', // 10% opacity
  borderRadius: theme.shape.borderRadius
});

/**
 * Product chip styling - used for displaying product-related tags and labels
 */
export const createProductChipStyles = (theme: Theme) => ({
  marginLeft: theme.spacing(1),
  fontSize: 14,
  color: '#65AFAD',
  borderColor: '#65AFAD'
});

/**
 * Target chip styling - used for highlighting target or selected items
 */
export const createTargetChipStyles = (theme: Theme) => ({
  marginLeft: theme.spacing(1),
  fontSize: 14,
  backgroundColor: '#65AFAD',
  color: theme.palette.common.white,
  marginRight: 'auto'
});

/**
 * Common form container styling - provides consistent spacing and layout
 */
export const createFormContainerStyles = (theme: Theme) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column' as const,
  gap: theme.spacing(2)
});

/**
 * Form section header styling - for section titles within forms
 */
export const createFormSectionHeaderStyles = (theme: Theme) => ({
  marginBottom: theme.spacing(1),
  fontWeight: 600,
  color: theme.palette.text.primary
});

/**
 * Form action button container - consistent spacing for form buttons
 */
export const createFormActionStyles = (theme: Theme) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`
}); 